// src/services.jsx
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE = "https://manavadhikarforum.in/api"
// const API_BASE = "/api"; //Production
// const API_BASE = "http://localhost:5000"; // Local 

// 🔹 Normal Axios instance
const api = axios.create({
  baseURL: API_BASE,
});

// 🔹 Admin Axios instance (with admin token)
const adminApi = axios.create({
  baseURL: API_BASE,
});

// Request interceptor → attach token
adminApi.interceptors.request.use(
  (config) => {
    const stored = localStorage.getItem("maf-admin");
    const parsed = stored ? JSON.parse(stored) : null;
    const token = parsed?.token; // ✅ backend must send token in login response
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle 401
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      toast.error("Session expired. Please login again.");
      localStorage.clear();
      window.location.href = "/admin-login";
    }
    return Promise.reject(error);
  }
);

// 🟢 Auth functions
export const getOtp = async (email) => {
  return api.post("/api/admin/auth/request-otp", { email });
};

export const verifyOtp = async (payload) => {
  const res = await api.post("/api/admin/auth/verify-otp", payload);
  if (res.data?.token) {
    localStorage.setItem(
      "maf-admin",
      JSON.stringify({
        ...res.data,
        email: res.data.email ?? payload.email,
      })
    );
  }
  return res;
};

export const getAdminAuth = () => {
  const stored = localStorage.getItem("maf-admin");
  return stored ? JSON.parse(stored) : false;
};

/** Only this admin may use full-profile member edit (UI + backend 403 for others). */
export const ADMIN_FULL_PROFILE_EDITOR_EMAIL = "sharmasubham@gmail.com";

export const canEditMemberFullProfile = () => {
  const email = (getAdminAuth()?.email || "").toLowerCase();
  return email === ADMIN_FULL_PROFILE_EDITOR_EMAIL.toLowerCase();
};

// 🟢 Generic CRUD requests
export const apiGet = (url, params = {}) => api.get(url, { params });
export const apiPost = (url, data) => api.post(url, data);
// export const apiPut = (url, data) => api.put(url, data);
export const apiDelete = (url) => api.delete(url);

// 🔹 ADMIN CRUD requests (with token)
export const adminGet = (url, params = {}) => adminApi.get(url, { params });
export const adminPost = (url, data) => adminApi.post(url, data);
export const adminPut = (url, data) => adminApi.put(url, data);
export const adminDelete = (url) => adminApi.delete(url);

// 🟢 File upload
export const uploadFileAuth = (url, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return adminApi.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// export const uploadFileNoAuth = (url, file) => {
//   const formData = new FormData();
//   formData.append("file", file);
//   return axios.post(`${API_BASE}${url}`, formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
// };


// Normal user (no token)
export const createMemberApi = (data, photoFile, aadhaarFile) => {
  const formData = new FormData();

  // Append all text fields
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  // Append files (field names must match backend: "photo", "aadhaar")
  if (photoFile) {
    formData.append("photo", photoFile);
  }
  if (aadhaarFile) {
    formData.append("aadhaar", aadhaarFile);
  }

  return api.post("/api/payment/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Public: initiate renewal payment (₹500)
export const renewMemberPaymentApi = (memberId) => {
  return api.post(`/api/payment/renew/${memberId}`);
};

export const createAdminMemberApi = (data, photoFile, aadhaarFile) => {
  const formData = new FormData();

  // Append all text fields
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  // Append files (field names must match backend: "photo", "aadhaar")
  if (photoFile) {
    formData.append("photo", photoFile);
  }
  if (aadhaarFile) {
    formData.append("aadhaar", aadhaarFile);
  }

  return adminApi.post("/api/members/admin/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/** PUT multipart; append only fields you send (see API docs). */
export const updateAdminMemberFullProfileApi = (memberId, formData) => {
  return adminApi.put(
    `/api/members/admin/full-profile/${memberId}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};


export const creatEarlyMemberApi = (data, photoFile, aadhaarFile, idCardFile) => {
  const formData = new FormData();

  // Append all text fields
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  // Append files (field names must match backend: "photo", "aadhaar")
  if (photoFile) {
    formData.append("photo", photoFile);
  }
  if (aadhaarFile) {
    formData.append("aadhaar", aadhaarFile);
  }
  if (idCardFile) {
    formData.append("idCard", idCardFile);
  }

  return adminApi.post("/api/members/early/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
